import { parse } from "date-fns";
import getFormattedDateRange from "@/assets/js/utils/get-formatted-date-range";
import { axiosOffers } from "@/services/scopes/axios-offers";

export function getBookingOffers({ id, max_group_size, min_price }, offset = 0, limit = 20) {
  return new Promise((resolve) => {
    let query = '';
    query += `offset=${offset}`;
    query += limit ? `&limit=${limit}` : '';

    axiosOffers
      .getPublicOffers(id,  query)
      .then(
        ({
          data: {
            data: { offers, total },
          },
        }) => {
          const mappedOffers = offers
            .map((offer) => {
              return {
                ...offer,
                formattedRange: getFormattedDateRange.call(
                  this,
                  parse(offer.dateFrom, "dd.MM.yyyy", new Date()),
                  parse(offer.dateTo, "dd.MM.yyyy", new Date())
                ),
                formattedRangeFullMonth: getFormattedDateRange.call(
                  this,
                  parse(offer.dateFrom, "dd.MM.yyyy", new Date()),
                  parse(offer.dateTo, "dd.MM.yyyy", new Date()),
                  true
                ),
              };
            })
            .sort(
              (a, b) =>
                parse(a.dateFrom, "dd.MM.yyyy", new Date()) -
                parse(b.dateFrom, "dd.MM.yyyy", new Date())
            );

          if (mappedOffers.length === 0) {//@todo костыль для того чтобы работал выбор из списка :(
            mappedOffers.push({
              id: 1,
              freeSpaces: +max_group_size,
              totalSpaces: +max_group_size,
              formattedRange: this.$t("bookingPopup.fieldset.customDates"),
              price: +min_price,
              range: [],
              custom: true,
            });
          }

          resolve({mappedOffers, total});
        }
      )
      .catch(console.log.bind(console));
  });
}

export function getOfferFromLocalStorage(offers) {
  const date_id = localStorage.getItem('date_id');

  return offers.find(({ id }) => id.toString() === date_id)
    || (offers.find(({ freeSpaces }) => freeSpaces > 0) || offers[0]);
}
